import { render, staticRenderFns } from "./ProductCenter.vue?vue&type=template&id=4e6fff49&scoped=true&"
import script from "./ProductCenter.vue?vue&type=script&lang=js&"
export * from "./ProductCenter.vue?vue&type=script&lang=js&"
import style0 from "./ProductCenter.vue?vue&type=style&index=0&id=4e6fff49&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6fff49",
  null
  
)

export default component.exports